import { SVGProps, Ref, forwardRef } from 'react';

export const RocketFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M4.256 16.5A3.244 3.244 0 0 1 7.5 19.744c0 3.635-3.977 3.244-6.487 3.244 0-2.51-.392-6.488 3.243-6.488"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.883 6.877c1.977-2.379 6.853-6.733 12.97-5.729 1.004 6.117-3.351 10.992-5.73 12.969.401 3.29-.816 6.54-4.73 8.883-.14-1.946-.549-3.67-1.228-5.15l-.948.49-4.557-4.557.49-.95c-1.462-.67-3.178-1.084-5.15-1.225 2.343-3.914 5.593-5.132 8.883-4.731M15 7.25c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.438-1.75-1.75-1.75"
                fill="currentColor"
            />
        </g>
    </svg>
));
RocketFilledSize24Glyph.displayName = 'RocketFilledSize24Glyph';
